export default __webpack_public_path__ + "ide-project-images/98a6d038d89d2cb2582bf0951761da83.png";